<template>
    <div id="agent-list-page">
        <div v-show="noticeVisible" class="notice content">
            <div>
                <i class="iconfont">&#xe6e5;</i>
                <span>给精灵设置一个代理账号后(账号和密码务必保密)，代理账号可以通过&emsp;
                <a href="https://www.ztcjl.com/kcjl/agentLogin">https://www.ztcjl.com/kcjl/agentLogin</a>&emsp;登录精灵，登录后拥有与您相同的开车精灵使用权限</span>
            </div>
            <i class="iconfont" @click="noticeDisplay">&#xe6c7;</i>
        </div>
        <div class="agent-list content" :style="`height:${agentHeight}px`">
            <div class="content-head align-center flex-between">
                <div class="f14 font-bold">设置精灵代理账号</div>
                <el-button type="primary" @click="addAgentDialogs">添加代理账号</el-button>
            </div>
            <div class="content-body">
                <template>
                    <el-table :data="agentList" stripe style="width: 100%">
                        <el-table-column>
                            <template v-slot:header>
                                <div class="table-tl pl20">账户名称</div>
                            </template>
                            <template v-slot:default="scope">
                                <div class="table-tl pl20">{{scope.row.name}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="状态">
                            <span class="color-box">代理中</span>
                        </el-table-column>
                        <el-table-column>
                            <template v-slot:header>
                                <div class="table-tr pr70">操作</div>
                            </template>
                            <template v-slot:default="scope">
                                <div class="table-tr pr50">
                                    <span class="theme-color pointer pr6" @click="editAgent(scope.$index)">编辑</span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span class="theme-color pointer pl6"
                                          @click="deleteAgent(scope.row.name, scope.$index, scope.row.id)">删除</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
        </div>
        <el-dialog title="新增代理账户" :visible.sync="addAgentDialog" custom-class="small-dialog">
            <el-form :label-position="labelPosition" label-width="80px" :model="agentLogin">
                <el-form-item label="账户名称">
                    <el-input v-model="agentLogin.username" placeholder="用户名必须是淘宝网账号（5~25个字符）"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model="agentLogin.password" placeholder="6~16个字母或符号的组合密码" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码">
                    <el-input v-model="agentLogin.repassword" placeholder="再输入一次密码" type="password"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addAgent(0)">保存</el-button>
                <el-button @click="addAgentDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑代理账户" :visible.sync="editAgentDialog" custom-class="small-dialog">
            <el-form :label-position="labelPosition" label-width="80px" :model="agentLogin">
                <el-form-item label="账户名称">
                    <el-input v-model="agentLogin.username" placeholder="用户名必须是淘宝网账号（5~25个字符）"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model="agentLogin.password" placeholder="6~16个字母或符号的组合密码" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码">
                    <el-input v-model="agentLogin.repassword" placeholder="再输入一次密码" type="password"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addAgent(agentLogin.agent_id)">更新</el-button>
                <el-button @click="editAgentDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <ConfirmDialog ref="confirmDialog"></ConfirmDialog>
    </div>
</template>

<script>
    import md5 from "js-md5";
    import ConfirmDialog from "../../components/ConfirmDialog";
    export default {
        name: "ShopDeleteWord",
        components: { ConfirmDialog },
        data() {
            return {
                agentHeight: 0,
                noticeHeight: 0,
                noticeVisible: true,
                addAgentDialog: false,
                editAgentDialog: false,
                delId: null,
                delIndex: null,
                delName: null,
                agentList: [],
                labelPosition: "right",
                agentLogin: {
                    name: "",
                    username: "",
                    password: "",
                    repassword: "",
                    agent_id: "",
                },
            };
        },
        beforeMount() {
            this.getAgentList();
            this.getHeight();
        },
        methods: {
            //关闭notice显示
            getHeight() {
                this.agentHeight = (document.documentElement.clientHeight - 146) + this.noticeHeight;
            },
            noticeDisplay() {
                this.noticeVisible = false;
                this.noticeHeight = 54;
                this.getHeight();
            },
            getAgentList() {
                this.$axios(
                    "/api/kcjl/shop/",
                    {
                        func: "get_user_agent_list",
                    },
                    (res) => {
                        this.agentList = res.data;
                    }
                );
            },
            addAgent(id) {
                if (this.agentLogin.username.length < 5 || this.agentLogin.username.length > 25) {
                    this.$notification("error", "用户名必须是淘宝网账号 且字符长度需在　5~25个字符之间");
                } else if (this.agentLogin.repassword.length < 6 || this.agentLogin.repassword.length > 16) {
                    this.$notification("error", "密码长度必须在　6~16个字符之间");
                } else if (this.agentLogin.password != this.agentLogin.repassword) {
                    this.$notification("error", "填入的密码和确认密码不一致，请重新填写密码")
                } else if (this.agentLogin.password == this.agentLogin.repassword) {
                    this.$axios(
                        "/api/kcjl/shop/",
                        {
                            func: "set_agent",
                            name: this.agentLogin.username,
                            password: md5(this.agentLogin.password),
                            agent_id: id,
                        },
                        () => {
                            this.addAgentDialog = false;
                            this.editAgentDialog = false;
                            this.getAgentList();
                            if (id == 0) {
                                this.agentLogin.name = '',
                                    this.agentLogin.username = ''
                            }
                        }
                    );
                }

            },
            addAgentDialogs() {
                this.addAgentDialog = true;
                this.agentLogin.agent_id = '';
                this.agentLogin.name = '';
                this.agentLogin.username = '';
                this.agentLogin.password = '';
                this.agentLogin.repassword = '';
            },
            editAgent(index) {
                this.editAgentDialog = true;
                this.agentLogin.agent_id = this.agentList[index].id;
                this.agentLogin.username = this.agentList[index].name;
            },
            deleteAgent(name, index, id) {
                this.delId = id;
                this.delIndex = index;
                this.delName = name;
 
                this.$refs.confirmDialog.params = {
                    visible: true,
                    content: '请确认是否删除 11111 代理账号?',
                    callback: () => {
                        this.$axios(
                            "/api/kcjl/shop/",
                            {
                                func: "delete_agent",
                                agent_id: this.delId,
                            },
                            () => {
                                // 本地缓存删除数据
                                this.agentList.splice(this.delIndex, 1);
                                this.delId = null;
                                this.delIndex = null;
                                this.delName = null;
                            }, '删除成功'
                        );
                    }
                }

            }
        },
        mounted() {
            window.onresize = () => {
                return this.getHeight();
            }
        },
    };
</script>
<style scoped lang="scss">
    #agent-list-page {
        padding: 0 20px;

        .color-box {
            width: 54px;
            height: 22px;
            background-color: #e5f8f2;
            color: $base-green;
            text-align: center;
            border-radius: 2px;
        }

        .agent-list {
            margin: auto;
            padding: 0 20px;
            background: #fff;

            .content-body {
                border-radius: 4px;
                border: 1px solid $base-table-border;

                .list-head {
                    height: 48px;
                    background-color: $base-table-border;
                    list-style-type: none;

                    li {
                        margin: 15px;
                    }
                }

                .list-body {
                    list-style-type: none;

                    li {
                        margin: 15px;
                    }
                }
            }
        }
    }
</style>